import { defineComponent } from 'vue';
import Menu from '@/components/Menu/pc.vue';
// import Menu from '@/components/Menu/pcMenuV2.vue'
import HeaderNav from '../HeaderNav/index.vue';
import useLayout from './useLayout';
export default defineComponent({
    name: 'LayoutPcComp',
    components: {
        Menu,
        HeaderNav
    },
    setup () {
        const { isFullscreen, isAsideCollapsed, handleCollapseStatusChange } = useLayout();
        return {
            isFullscreen,
            isAsideCollapsed,
            handleCollapseStatusChange
        };
    }
});
